import React from 'react'
import { FormattedMessage } from "react-intl";
import UCButton from "../../../../buttons";
import { csvSpinners } from 'constants/appConstants';

const CustomSubmitButton = (props) => {
  const { className, buttonClassName, style, buttonStyle, disabled, content, onSubmit, files, validationError } = props

  const _disabled =
    files.some(f => ['preparing', 'getting_upload_params', 'uploading'].includes(f.meta.status)) ||
    !files.some(f => ['ready'].includes(f.meta.status)) ||
    validationError

  const handleSubmit = () => {
    onSubmit(files.filter(f => ['headers_received', 'done'].includes(f.meta.status)))
  }

  return (
    <UCButton
      spinner={{
        name: csvSpinners.guestProfilesCSV,
        size: 20,
      }}
      className={buttonClassName}
      style={buttonStyle}
      type="primary"
      text={<FormattedMessage id="guestHeader.modalUpload.upload" />}
      dataTestId="uploadbulk"
      onClick={handleSubmit}
      disabled={disabled || _disabled}
    />
  )
}

export default CustomSubmitButton